import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FundsPortalService, LocalStorageService } from 'src/app/core/core.module';
import { AtramModalComponent } from 'src/app/shared/components/atram-modal/atram-modal.component';

@Component({
  selector: 'app-forgot-password-mfa',
  templateUrl: './forgot-password-mfa.component.html',
  styleUrls: ['./forgot-password-mfa.component.less']
})
export class ForgotPasswordMfaComponent implements OnInit {

  @ViewChild('atramModal')
  public atramModal: AtramModalComponent = new AtramModalComponent;

  public searchFormGroup!: FormGroup;
  public isError: boolean = false;
  public isInvalidCode: boolean = false;
  public isNotValidInputs: boolean = false;
  public invalidText: string = '';

  constructor(
    public fundsPortalService: FundsPortalService,
    public router: Router,
    public localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    const email = this.localStorageService.get('forgot_password_email');
    const companyCode = this.localStorageService.get('forgot_password_company_code');

    if (!email || !companyCode) {
      this.router.navigateByUrl('/forgot-password', { skipLocationChange: false });
      return;
    }

    this.initializeFormGroup();
  }

  initializeFormGroup(): void {
    this.searchFormGroup = new FormGroup({
      otp: new FormControl('', [Validators.required])
    });
  }

  onOtpChange(e: any): void {
    this.searchFormGroup.get('otp')?.setValue(e);
    if (this.searchFormGroup.get('otp')?.value.length === 6) {
      this.isError = false;
      this.isInvalidCode = false;
    }
  }

  proceed(): void {
    if (this.searchFormGroup.get('otp')?.value.length < 6) {
      this.isError = true;
      this.isNotValidInputs = true;
      return;
    }

    this.isNotValidInputs = false;
    this.submit();
  }

  submit(): void {
    const body = {
      email: this.localStorageService.get('forgot_password_email'),
      company_code: this.localStorageService.get('forgot_password_company_code'),
      code: this.searchFormGroup.get('otp')?.value
    };

    this.fundsPortalService.postForgotPasswordVerifyMfa(body).subscribe({
      next: (data: any) => {
        if (data['response_result'] !== '0001') {
          this.isInvalidCode = true;
          this.invalidText = data['response_description'] || 'Invalid code. Please try again.';
          return;
        }

        const responseData = data?.response_data || {};
        const forgotPasswordCode =
          responseData?.forgot_password_code ||
          responseData?.code ||
          responseData?.reset_code ||
          responseData?.token ||
          null;

        if (forgotPasswordCode) {
          this.localStorageService.set('forgot_password_code', forgotPasswordCode, 1800);
          const authToken = responseData?.auth_token;
          if (authToken?.access_token) {
            this.localStorageService.set('bearer', authToken.access_token, authToken.expires_in);
          }
          this.router.navigateByUrl(`/forgot-password/change-password?code=${encodeURIComponent(forgotPasswordCode)}`, { skipLocationChange: false });
          return;
        }

        this.isInvalidCode = true;
        this.invalidText = 'Verification succeeded but no reset code was returned. Please try again.';
      },
      error: (error: any) => {
        this.isInvalidCode = true;
        this.invalidText = error['response_description'] || error['response_data']?.['message'] || 'Invalid code. Please try again.';
      }
    });
  }

  goToForgotPassword(): void {
    this.router.navigateByUrl('/forgot-password', { skipLocationChange: false });
  }

  goToSignIn(): void {
    this.router.navigateByUrl('', { skipLocationChange: false });
  }
}
